export default "__VITE_ASSET__485cafca__"